import AuthCommentForm from './authCommentForm';

const authCommentFormConfig = {
  name: 'authCommentForm',
  class: AuthCommentForm,
  querySelector: {
    contents: '.auth-comment-form__contents',
  },
  querySelectorAll: {},
  options: {},
};

export default authCommentFormConfig;
